import { ProtocolKind } from './types'

/**
 * Defaults per protocol; a catalog model's `params` and a till's overrides are merged over them. Documented here as the
 * contract System Admin validates against (POS.md §18.9 §1).
 */
export const PROTOCOL_DEFAULTS: Record<ProtocolKind, Record<string, unknown>> = {
  html: { page: 'roll', width_mm: 80, font_size_pt: 9 },
  escpos: { paper_width_mm: 80, chars_per_line: 48, code_page: 0, cut: 'partial', drawer_pin: 0, drawer_on_ms: 50, drawer_off_ms: 500, barcode_height_dots: 64, qr: true },
  star: { paper_width_mm: 80, chars_per_line: 48, cut: 'partial' },
  tspl: { dpi: 203, label_width_mm: 50, label_height_mm: 30, gap_mm: 2, speed: 4, density: 8, margin_mm: 2 },
  zpl: { dpi: 203, label_width_mm: 50, label_height_mm: 30, margin_mm: 2 },
  epl: { dpi: 203, label_width_mm: 50, label_height_mm: 30, gap_mm: 3, margin_mm: 2 },
  serial_scale: {},
  none: {},
}

export const resolveParams = (protocol: ProtocolKind, ...layers: (Record<string, unknown> | undefined)[]) =>
  Object.assign({}, PROTOCOL_DEFAULTS[protocol], ...layers.filter(Boolean)) as Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
